
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Classes",
      function () {
        return require("private-next-pages/ShuffleMaps/Classes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Classes"])
      });
    }
  